import { FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { memo } from "react";
import { ReceivedMessageCaleClassifications } from "./ReceivedMessageCaleClassifications";
import { ReceivedMessageCalePreferences } from "./ReceivedMessageCalePreferences";
import { ReceivedCaleSpecialties } from "./ReceivedCaleSpecialties";
import { IReturnAutomationFieldsProps } from "../models";
import { useTranslation } from "react-i18next";
import { ReceivedMessageCalendars } from "./ReceivedMessageCalendars";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessages.";

export const ReturnAutomationFields = memo(
  ({ automationCode }: IReturnAutomationFieldsProps) => {
    const { t } = useTranslation();

    return (
      <>
        <Grid item sm={12} textAlign={"end"}>
          <SwitchInput
            name="showAppAndOnlineCalendar"
            label={t(translationPath + "show_app_and_online_calendar")}
          />
          <SwitchInput name="enable" label={t(translationPath + "enable")} />
        </Grid>

        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
          xs={12}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight="bold">
                {t(translationPath + "if")}
              </Typography>
            </Grid>

            <ReceivedMessageCalePreferences automationCode={automationCode} />

            {automationCode !== "21" && <ReceivedCaleSpecialties />}

            <ReceivedMessageCaleClassifications
              automationCode={automationCode}
            />

            <ReceivedMessageCalendars />
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight="bold">
                {t(translationPath + "then")}
              </Typography>
            </Grid>

            <Grid item sm={12}>
              <FormInput
                type="number"
                size="small"
                name="returnDays"
                fullWidth
                label={t(translationPath + "return_days")}
              />
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  },
);
